// extracted by mini-css-extract-plugin
export default {"externalLinksWrapper":"style_externalLinksWrapper__Nhuo8"};